import { render, staticRenderFns } from "./banner_search.vue?vue&type=template&id=620b1fff&scoped=true&"
import script from "./banner_search.vue?vue&type=script&lang=js&"
export * from "./banner_search.vue?vue&type=script&lang=js&"
import style0 from "./banner_search.vue?vue&type=style&index=0&id=620b1fff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b1fff",
  null
  
)

export default component.exports